import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Tooltip } from "react-tooltip";

interface IconButtonState {
  onClickButton?: any;
  tooltipText: string;
  icon: any;
  color?: string;
  className?: string;
  disabled?: boolean;
}

const IconButton = ({
  onClickButton = null,
  tooltipText,
  icon,
  color = "text-muted",
  className = "",
  disabled = false,
}: IconButtonState) => {
  return (
    <>
      <FontAwesomeIcon
        data-tooltip-id="tooltip"
        data-tooltip-content={tooltipText}
        icon={icon}
        color={color}
        onClick={!disabled ? onClickButton : undefined}
        className={`${color} me-1 ${!disabled ? "cursor-pointer" : "cursor-not-allowed"} ${className}`}
      />
      <Tooltip id="tooltip" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />
    </>
  );
};

export default IconButton;
